module.exports = __webpack_public_path__ + "media/icons/float-center-1d0bd3e6.svg";